<script>
	import client from "../../services/client";
	import { loading, editEvData } from "../../store/store";
	import { onMount } from "svelte";
	import { extractErrorMessage } from "../../utils/misc";
	import CreateEvAccForm from "./CreateEvAccForm.svelte";
	import LoaderContainer from "../../components/Loader/LoaderContainer.svelte";

	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});

	let data = [];

	onMount(async () => {
		loading.set(true);
		try {
			const resDetail = await client(
				`/v1/evChargingAccount/${params.id}`,
				{
					method: "GET",
					version: "evCharging",
				}
			);
			data = resDetail.data.data
			editEvData.set(data)

			loading.set(false);
		} catch (error) {
			extractErrorMessage(error);
			loading.set(false);
		}
	});
</script>

{#if !editEvData || !editEvData.id}
	<LoaderContainer>
		<CreateEvAccForm/>
	</LoaderContainer>
{:else}
	<CreateEvAccForm/>
{/if}
